var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "off_market_svg__el_7p8CXewcj",
    x: 0,
    y: 0,
    viewBox: "0 0 717 581",
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "off_market_svg__defs3903"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "off_market_svg__Strips1_1",
    width: 2,
    height: 1,
    patternTransform: "scale(10)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "off_market_svg__rect5512",
    fill: "#000",
    stroke: "none",
    d: "M0-.5h1v2H0z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style3810"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.7 512.7v-95.6H399.2v93.6",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 4.8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_iNfdl8Ooj6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.4 427.2v84.5",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 4.8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_LRPApU7dyh"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M374.2 514.2h157.2l-2.4 2.4V384.5l2.4 2.4-157.2-.6v-3.6l157.2-.6c1.3 0 2.4 1.1 2.4 2.4v132.2c0 1.3-1.1 2.4-2.4 2.4H374.2v-4.9z",
    fill: "#1d1d1c",
    id: "off_market_svg__el_g4Q-q31XTM"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M313.8 423.6h32.8v32.8h-32.8z",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 4.8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_RD2gMX9tvi"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.3 516.1l-.4-95.9 2.4 2.4h-42.7l2.4-2.4v95.9h-4.8v-95.9c0-1.3 1.1-2.4 2.4-2.4h42.7c1.3 0 2.4 1.1 2.4 2.4l-.4 95.9h-4z",
    fill: "#1d1d1c",
    id: "off_market_svg__el_O3U4fwX6e8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.8 516.6V240.9h-.9 38.6s28.1-1.8 42.1 29c0 0 14.9 30.7 39.5 30.7h64l1.5-.9v216.9H189.8",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 4.8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_iH6mC_PiU_"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M450.3 442.9c-.3 0-.9-.1-1.3-.1-.5 0-1 0-1.5.1-.5 0-1 .1-1.5.2s-1 .2-1.4.4c-1.8.6-3.6 1.5-5 2.8-.4.3-.7.7-1 1.1-.2.2-.3.4-.5.5l-.4.6c-.3.4-.6.8-.8 1.2l-.7 1.4c-.3.4-.4.9-.6 1.4l-.5 1.5c-.3 1-.5 2.1-.7 3.1-.2.7-.3 1.2-.5 1.8-.2.6-.4 1.1-.6 1.7-.4 1.1-.9 2.2-1.4 3.3-1 2.2-2.3 4.2-3.9 6.1s-3.6 3.5-5.9 4.6c-1.2.5-2.4.8-3.7 1-1.3.2-2.6.1-3.8 0-.9-.1-1.5-.9-1.4-1.8s.9-1.5 1.8-1.4h.1c1 .1 2 .1 2.9 0 1-.2 1.9-.4 2.8-.8 1.7-.8 3.3-2.1 4.6-3.7 1.3-1.6 2.3-3.4 3.2-5.4l1.2-3c.3-1 .7-2.1.8-3 .7-4.6 2.4-9.5 6.1-13.2 1.8-1.8 4.1-3.2 6.6-4 .6-.2 1.2-.3 1.9-.5.6-.1 1.3-.2 1.9-.3.6-.1 1.3-.1 1.9-.1.7 0 1.2 0 2 .1 1.3.1 2.2 1.3 2 2.5-.1 1.3-1.3 2.2-2.5 2l-.2-.1z",
    fill: "#1d1d1c",
    id: "off_market_svg__el_32ZP-OQ5Bj"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M418.8 162.1l1.7-17.9 10.9.8-1.7 17.1",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 3.934,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_RqbADePbfP"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.6 361.7l7.9-87",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 3.934,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_xlRNDNeYgCu"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.7 370.1l8.7-95.4",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 3.934,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_Mmwf-B12IrE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M520.3 286h-.8l-212.6-19c-5-.4-8.7-4.9-8.3-9.9l8.3-96.2c.5-5.4 7.3-7.8 11.9-7.5l210.6 18.1c2.4.2 4.6 1.4 6.2 3.2 1.6 1.9 2.3 4.2 2.1 6.7l-8.3 96.2c-.5 4.8-4.5 8.4-9.1 8.4zm-.5-4.1c2.8.2 5.3-1.8 5.5-4.6l8.3-96.2c.1-1.4-.3-2.7-1.2-3.7s-2.1-1.7-3.4-1.8l-210.6-18.1c-3.2-.3-7.3 1.4-7.5 3.8l-8.3 96.2c-.2 2.8 1.8 5.3 4.6 5.5l212.6 18.9z",
    fill: "#1d1d1c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M290.9 395.9c-26.2.3-52.7.5-78.9.4-1.1 0-2.1-.9-2.1-2.1l.1-40c0-1.1.9-2 2-2l78 .2c1 0 1.7.8 1.8 1.7.1 6.9.1 13.8 0 20.7l-.2 10.3-.1 5.1-.1 2.6c0 .8 0 1.8-.3 2.4l-.2.7zm-2.2-3.4c-.1-.8-.2-1.4-.2-2.1l-.1-2.4-.1-4.9-.2-9.7c-.1-6.4-.1-12.8 0-19.3l1.8 1.8-78 .2 2-2 .1 40-2.1-2.1c25.5-.1 50.8 0 76.3.4l.5.1z",
    fill: "#1d1d1c",
    id: "off_market_svg__el_hIfuqhyHbfW"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 348.7v-31.5h35v31.5",
    fill: "none",
    stroke: "#1d1d1c",
    strokeWidth: 4.8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M614.6 365.6l79 1.6c.9 0 1.7.8 1.6 1.7 0 .9-.8 1.6-1.7 1.6l-79-.4c-1.3 0-2.3-1-2.3-2.3.1-1.2 1.1-2.2 2.4-2.2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_gWjcwkiFnG2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M576.9 187.4l60.3-35.4c.8-.5 1.8-.2 2.2.6.5.8.2 1.8-.6 2.2l-59.7 36.6c-1.1.7-2.5.3-3.2-.8-.5-1.1-.1-2.5 1-3.2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_wxhvMz8dkJI"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M604.7 432.6l78.3 22.1c.9.2 1.4 1.2 1.1 2-.2.9-1.1 1.4-2 1.1l-78.7-20.9c-1.2-.3-2-1.6-1.6-2.8.3-1.1 1.6-1.8 2.9-1.5-.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_RSWYgG42jfE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M610.4 272.7l77.2-23.4c.9-.3 1.8.2 2 1.1.3.9-.2 1.8-1.1 2L611.7 277c-1.2.4-2.5-.3-2.9-1.5-.3-1.2.3-2.4 1.6-2.8-.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_0r83vIg_ZKA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9 187.5L127.4 132c-.6-.7-.6-1.7 0-2.3s1.7-.6 2.3 0l54.5 54.5c.9.9.9 2.4 0 3.3s-2.3.9-3.3 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_cMD-ltQBmMl"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.7 272l-79.3-32.1c-.8-.3-1.2-1.3-.9-2.1s1.3-1.2 2.1-.9l79.7 30.9c1.2.5 1.8 1.8 1.3 3-.3 1.1-1.7 1.7-2.9 1.2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_bw1NZ7qECJd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 371.2L24.1 373c-.9 0-1.7-.7-1.7-1.6s.7-1.6 1.6-1.7l90.5-3.2c1.3 0 2.3.9 2.4 2.2 0 1.3-1 2.4-2.3 2.5.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_6Uh3EeI0CP1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.6 466.9l-50 17",
    fill: "none",
    stroke: "#1c8be6",
    strokeWidth: 4.205,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_cEAisSPbb-1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.6 434.6L43.5 453c-.9.2-1.8-.3-2-1.2-.2-.9.3-1.7 1.2-2l76.8-19.6c1.2-.3 2.5.4 2.8 1.7.3 1.1-.4 2.4-1.7 2.7z",
    fill: "#1c8be6",
    id: "off_market_svg__el__NMa34ofkYS"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 404.6L60.2 410c-.9.1-1.7-.6-1.8-1.5s.6-1.7 1.4-1.8l53.9-6.7c1.3-.2 2.4.7 2.6 2s-.7 2.5-2 2.6c.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_R0hFwic8nX4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.1 334.4l-60-6",
    fill: "none",
    stroke: "#1c8be6",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_eenhBqQQb30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1 301.4l-34-10",
    fill: "none",
    stroke: "#1c8be6",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_eadET0GLzJi"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M140.1 240.4l-27-18",
    fill: "none",
    stroke: "#1c8be6",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    id: "off_market_svg__el_jvq6JhkEblL"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M157.7 213.2l-46.6-35.5c-.7-.5-.9-1.6-.3-2.3.5-.7 1.6-.9 2.3-.3l47.4 34.5c1 .7 1.3 2.2.5 3.2s-2.2 1.2-3.3.4z",
    fill: "#1c8be6",
    id: "off_market_svg__el_W_U1MbOBnGD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M202.1 163.6l-20.4-34.3c-.5-.8-.2-1.8.6-2.2.8-.5 1.7-.2 2.2.5l21.6 33.7c.7 1.1.4 2.5-.7 3.2-1.1.5-2.6.2-3.3-.9z",
    fill: "#1c8be6",
    id: "off_market_svg__el_fRPpYahyjB7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M230.2 144.6l-20.6-42.5c-.4-.8-.1-1.8.8-2.2.8-.4 1.8-.1 2.2.7l21.7 41.9c.6 1.1.1 2.5-1 3.1s-2.5.2-3.1-1z",
    fill: "#1c8be6",
    id: "off_market_svg__el_PJjCYIRjo2v"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M594.5 463.8l35.7 16.6c.8.4 1.2 1.4.8 2.2-.4.8-1.4 1.2-2.2.8L592.6 468c-1.2-.5-1.7-1.8-1.2-3s1.9-1.8 3.1-1.2c0-.1 0-.1 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_7neI8dRmmRv"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M612.9 399.6l50.9 7.7c.9.1 1.5 1 1.4 1.9s-.9 1.5-1.8 1.4l-51.1-6.3c-1.3-.2-2.2-1.3-2-2.6s1.3-2.3 2.6-2.1c-.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_2Aik6Bcvj1e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M618.2 331.6l59.1-7.3c.9-.1 1.7.5 1.8 1.4s-.5 1.7-1.4 1.8l-58.9 8.7c-1.3.2-2.4-.7-2.6-1.9-.1-1.4.7-2.5 2-2.7z",
    fill: "#1c8be6",
    id: "off_market_svg__el_6XwoalOYep3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M615.1 301.1l32.6-5.4c.9-.2 1.8.5 1.9 1.4.1.9-.4 1.7-1.3 1.9l-32.4 6.6c-1.2.3-2.5-.5-2.7-1.8-.2-1.2.6-2.4 1.9-2.7z",
    fill: "#1c8be6",
    id: "off_market_svg__el_y1K4MHbtbQO"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M603.9 242.6l39.7-10.9c.9-.2 1.8.3 2 1.2s-.3 1.7-1.1 2L605.2 247c-1.2.4-2.5-.3-2.9-1.5-.4-1.2.3-2.5 1.6-2.9 0 .1 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el__7wyMQiyWda"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M593.1 215.3l28.3-12.4c.8-.4 1.8 0 2.2.8s0 1.7-.8 2.1L595 219.4c-1.1.6-2.5.1-3.1-1.1s0-2.4 1.2-3c-.1 0 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_lcfmtmWGxMP"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M559.6 163.6l27.4-21.5c.7-.6 1.7-.4 2.3.3.5.7.4 1.7-.2 2.3l-26.6 22.5c-1 .8-2.4.7-3.2-.3-.8-1-.7-2.4.3-3.3z",
    fill: "#1c8be6",
    id: "off_market_svg__el_XZ9jZ5uCQHi"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9 130l-17.4-60.2c-.3-.9.3-1.8 1.1-2 .9-.2 1.8.2 2 1.1l18.6 59.8c.4 1.2-.3 2.5-1.5 2.9-1.2.4-2.4-.3-2.8-1.6 0 .1 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_ikdeGoiCLhb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M534.3 142.9l32.5-39.6c.6-.7 1.6-.8 2.3-.2.7.6.8 1.6.3 2.3l-31.5 40.4c-.8 1-2.2 1.2-3.2.4s-1.2-2.2-.4-3.3c-.1.1 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_5XeW5Ns486w"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.8 120.7l-3.3-27.1c-.1-.9.5-1.7 1.4-1.8.9-.1 1.7.5 1.8 1.3l4.7 26.9c.2 1.3-.6 2.4-1.9 2.7-1.3.2-2.4-.6-2.7-2 0 .1 0 0 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_xzcH0AiT_zC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M507 125.7L523.6 94c.4-.8 1.4-1.1 2.2-.7s1.1 1.4.7 2.2l-15.4 32.3c-.5 1.1-1.9 1.6-3.1 1.1-1.1-.6-1.6-2-1-3.2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_Xt92LCpTAwo"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M320.8 112.6l-3.3-45.1c-.1-.9.6-1.7 1.5-1.8.9-.1 1.7.6 1.8 1.5l4.7 44.9c.1 1.3-.8 2.4-2.1 2.5-1.4.2-2.5-.7-2.6-2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_5ZIR0ZzNW1u"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M476.8 114.8L489.4 71c.3-.9 1.2-1.4 2-1.1.9.2 1.4 1.1 1.1 2L481.3 116c-.3 1.2-1.6 2-2.8 1.7s-2-1.6-1.7-2.9z",
    fill: "#1c8be6",
    id: "off_market_svg__el_avKhD_Xz83c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M360.8 104.4l.7-27c0-.9.8-1.6 1.7-1.6.9 0 1.6.7 1.6 1.6l.7 27c0 1.3-1 2.3-2.2 2.4-1.3 0-2.3-1-2.4-2.2l-.1-.2z",
    fill: "#1c8be6",
    id: "off_market_svg__el_ZZfuEn5HtCY"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M437.8 106.9l5.6-25.9c.2-.9 1.1-1.4 2-1.3.9.2 1.4 1 1.3 1.9l-4.4 26.1c-.2 1.3-1.4 2.1-2.6 1.9-1.3-.2-2.1-1.4-1.9-2.7 0 .1 0 .1 0 0z",
    fill: "#1c8be6",
    id: "off_market_svg__el_gzpAGnHo4k3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M398.8 103.1l5.7-43.9c.1-.9.9-1.5 1.8-1.4s1.5.9 1.4 1.8l-4.3 44.1c-.1 1.3-1.3 2.2-2.5 2.1-1.3-.2-2.2-1.4-2.1-2.7z",
    fill: "#1c8be6",
    id: "off_market_svg__el_MmOWalNj1K9"
  })));
}
export default SvgOffMarket;